import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Chip,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    capitalize,
    ButtonGroup,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Filters from '../../../components/Filters';
import PageContainer from '../../../components/PageContainer';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import CaseTable from '../../../components/CaseTable';
import {
    getCPDUnassignedBreachedCases,
    getFIUnassignedBreachedCases,
    getPublicUnassignedBreachedCases,
    getUnassignedBreachedCases,
} from '../../../redux/api/cases';
import { getPrivilegeStatus } from '../../../util';
import SelectInput from '../../../components/common/SelectInput';
import { Form, Formik } from 'formik';
import { getAllSubcategories } from '../../../redux/api/userMgt';

const UnassignedCases = ({ user }) => {
    const [processing, setProcessing] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [records, setRecords] = useState([]);
    const [relationshipOfficers, setRelationshipOfficers] = useState([]);
    const [values, setValues] = useState({});
    const [teams, setTeams] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState();
    const [paginationData, setPaginationData] = useState({});
    const [subCategories, setSubCategories] = useState([]);

    const init = async (start = 0, length = user.paginationSize) => {
        try {
            setProcessing(true);
            const res = await getUnassignedBreachedCases(
                { start, length },
                false,
                selectedGroup
            );
            const resp = await getAllSubcategories();
            setSubCategories(resp?.resultObject || []);
            setRecords(
                records?.length < start
                    ? res?.resultObject?.dataTableResponse?.data || []
                    : records.concat(
                          res?.resultObject?.dataTableResponse?.data || []
                      )
            );

            setRelationshipOfficers(
                res?.resultObject?.relationshipOfficers || []
            );
            setPaginationData({
                start,
                length,
                total: res?.resultObject?.dataTableResponse?.recordsTotal,
                totalFiltered:
                    res?.resultObject?.dataTableResponse?.recordsFiltered,
            });
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    const search = async (values = {}, closeSearchModal) => {
        try {
            const resp = await getUnassignedBreachedCases(values, true);
            if (resp?.statusCode == '000') {
                setRecords(resp?.resultObject?.data || []);
                setValues(values);
                enqueueSnackbar(
                    resp?.message ||
                        'Your report is being processed, kindly check the reports page for progress'
                );
                closeSearchModal();
                if (resp?.resultObject?.data?.length == 0) {
                    enqueueSnackbar('No result found for search parameters', {
                        variant: 'error',
                    });
                }
            } else {
                enqueueSnackbar(resp?.message || 'An error occurred', {
                    variant: 'info',
                });
            }
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    const setData = async (user) => {
        const arr = await new Promise((resolve) => {
            let count = -1;
            let list = [];
            user?.userData?.teams?.forEach(({ groupId, ...props }, key) => {
                const inList = Boolean(
                    list?.find((ls) => ls.groupId == groupId)
                );
                if (!inList) {
                    list.push({ ...props, groupId });
                }
                count += 1;
                if (key == count) resolve(list);
            });
        });

        setTeams(arr || []);
        setSelectedGroup(user?.userData?.teams?.[0]?.groupId || '');
    };

    const exportData = async () => {
        try {
            const resp = await getUnassignedBreachedCases(values, true);
            enqueueSnackbar(
                resp?.message ||
                    'Your report is being processed, kindly check the reports page for progress'
            );
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    useEffect(() => {
        if (selectedGroup) init(selectedGroup);
    }, [selectedGroup, user.paginationSize]);

    useEffect(() => {
        setData(user);
    }, [user]);

    return (
        <PageContainer
            pageTitle={'Unassigned Breached Cases'}
            processing={processing}
        >
            {Boolean(teams?.length > 1) && (
                <Formik
                    initialValues={{ team: selectedGroup }}
                    enableReinitialize
                >
                    {() => (
                        <Form className="p-2 mb-1 m-4 mt-0">
                            <SelectInput
                                options={teams}
                                field="groupId"
                                fieldDisplay="name"
                                label="Active Team"
                                id="team"
                                customChange={(name, value) => {
                                    setSelectedGroup(value);
                                }}
                            />
                        </Form>
                    )}
                </Formik>
            )}

            <CaseTable
                cases={records}
                showPendingActionsBtn={false}
                showAssignBtn
                showAssignFooterBtn
                showCloseCaseBtn={false}
                showDeEscalateCaseBtn={false}
                showEscalateCaseBtn={false}
                showResolveCaseBtn={false}
                relationshipOfficers={relationshipOfficers}
                exportFunction={exportData}
                searchFunction={search}
                initFunction={init}
                subCategories={subCategories}
                showRecategorizeCaseBtn
                paginationData={paginationData}
            />
        </PageContainer>
    );
};

export default connect(({ user }) => ({ user }))(UnassignedCases);
